import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n        padding: 0;\n        font-size: 13px;\n        line-height: 13px;\n      "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  button {\n    width: 100%;\n    & span {\n      ", "\n    }\n  }\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 40px 0;\n    flex: 1;\n  "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n    padding: 50px 0 60px;\n  "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n    height: 0;\n    overflow: hidden;\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  padding: 3rem 0 3.5rem;\n  height: auto;\n  position: relative;\n  ", "\n\n  ", "\n\n  ", "\n\n  #notes-form {\n    margin-top: 20px;\n    .notes-cells {\n      > div {\n        margin-bottom: 0;\n      }\n    }\n  }\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 20px;\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: 0;\n    height: auto;\n    margin-top: 34px;\n  "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 43px;\n  height: 85px;\n  margin-top: 58px;\n  ", "\n  ", "\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    width: 0;\n    max-width: none;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  width: 45%;\n  max-width: 792px;\n  ", "\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: 60px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    margin: 0 auto;\n    position: relative;\n    z-index: 2;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  width: 45%;\n  max-width: 725px;\n  margin-right: auto;\n  padding-bottom: 65px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    padding-left: 24px;\n    padding-right: 24px;\n    flex: 1;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    padding-left: 125px;\n    padding-right: 125px;\n    border-top: 1px solid #E0E0E0;\n    flex-direction: column;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    top: 10px;\n    left: 20px;\n    .main-menu__logo {\n      img {\n        width: 24px;\n      }\n    }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    top: 19px;\n    left: 34px;\n    z-index: 2;\n    .main-menu__logo {\n      margin: 0;\n      img {\n        width: 72px;\n      }\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    top: 30px;\n    left: 30px;\n    .main-menu__logo img{\n      max-width: 60px;\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50px;\n  left: 62px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    padding: 50px 0 0;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 80px 0 0;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding-left: 124px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 0 0 200px;\n  position: relative;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.7);\n  z-index: 10;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Loader = styled.div(_templateObject());
export var Container = styled.div(_templateObject2(), media.xxLargeScreen(_templateObject3()), media.xLargeScreen(_templateObject4()), media.mediumScreen(_templateObject5()));
export var Logo = styled.div(_templateObject6(), media.xxLargeScreen(_templateObject7()), media.xLargeScreen(_templateObject8()), media.mediumScreen(_templateObject9()));
export var Wrapper = styled.div(_templateObject10(), media.xLargeScreen(_templateObject11()), media.mediumScreen(_templateObject12()));
export var WrapperColLeft = styled.div(_templateObject13(), media.xLargeScreen(_templateObject14()), function (props) {
  return props.mobileCartOpened && media.xLargeScreen(_templateObject15());
}, media.mediumScreen(_templateObject16()));
export var WrapperColRight = styled.div(_templateObject17(), media.xLargeScreen(_templateObject18()));
export var Navigation = styled.div(_templateObject19(), media.xxLargeScreen(_templateObject20()), media.mediumScreen(_templateObject21()));
export var Checkout = styled.div(_templateObject22(), function (props) {
  return props.mobileCartOpened && media.xLargeScreen(_templateObject23());
}, media.xLargeScreen(_templateObject24()), media.mediumScreen(_templateObject25()));
export var CartSummary = styled.div(_templateObject26());
export var Button = styled.div(_templateObject27(), media.xxLargeScreen(_templateObject28()));